import React from 'react';
import CCMRSSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import ItemGrid from '../../../components/itemGrid';

export default function Page04({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = CCMRSSyle();
	return (
		<div style={style.outerStyle()}>
			<ItemGrid
				title='Foods'
				rows={[
					['Protein', 'Carbohydrates', 'Fats', 'Minerals'],
					['Chicken', 'Rice', 'Olive Oil', 'Vitamin D'],
					['Ground Beef', 'Sweet Potato', 'Avocado', 'Magnesium'],
					['Steak', 'Oatmeal', 'Nuts', 'Calcium'],
					['Ground Turkey', '', 'Fats from Fish', 'Zinc'],
					['Eggs', '', 'Fish Oil', 'Iron'],
					['Turkey Bacon', '', 'Flaxseed', 'Folate'],
					['', '', '', 'Vitamin B-12'],
				]}
			/>
			<NextBackNav message='Ready to continue?' mt={true} nextPressed={nextPressed} backPressed={backPressed} nextSlideExzists={nextSlideExzists} previousSlideExzists={previousSlideExzists} />
		</div>
	);
}
